import { TMapAttribute } from "../../types/TMapAttribute";
import { getEnvirotainerTruckIcon } from "../../models/Envirotainer/EnvirotainerConfig";
import * as Assets from "../../assets";

export class MapConfig {
	private readonly company: string;
	private readonly popupAttributes: string[];

	public constructor(company: string, popupAttributes: string[]) {
		this.company = company;
		this.popupAttributes = popupAttributes;
	}

	public getMapConfig(): TMapAttribute {
		return {
			getTruckIcon: (deviceId?: string) => (this.company.toUpperCase() === "ENVIROTAINER" ? getEnvirotainerTruckIcon(deviceId) : Assets.TruckWhite),
			defaultIcon: (deviceId?: string) => (this.company.toUpperCase() === "ENVIROTAINER" ? getEnvirotainerTruckIcon(deviceId) : Assets.TruckWhite),
			popupAttributes: this.popupAttributes,
		};
	}
}
